export default "__VITE_ASSET__Db38rHeI__"